<template>
  <div class="page">
    <el-breadcrumb>
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>实物订单</el-breadcrumb-item>
    </el-breadcrumb>

    <el-form :model="queryForm" :inline="true" size="small" class="margin-t-10">
      <el-form-item>
        <el-input v-model="queryForm.keyword" placeholder="搜索订单号/商品名称/用户昵称/手机号" clearable
          style="width: 280px;"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="getData">刷新</el-button>
      </el-form-item>
    </el-form>

    <el-tabs v-model="actTableType" type="card" @tab-click="handleTabChange">
      <el-tab-pane :label="'全部（' + counts.all + '）'" name="0"></el-tab-pane>
      <el-tab-pane :label="'待付款（' + counts.status0 + '）'" name="-1"></el-tab-pane>
      <el-tab-pane :label="'已完成（' + counts.status4 + '）'" name="4"></el-tab-pane>
      <el-tab-pane :label="'待退款（' + counts.status5 + '）'" name="5"></el-tab-pane>
    </el-tabs>

    <el-table v-loading="loading" :data="tableData" :header-cell-style="{background:'#F5F5F5'}" border size="mini"
      height="500px" style="width: 100%;">
      <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
      <el-table-column prop="order_items" label="商品信息" header-align="center">
        <template v-slot="{ row }">
          <GoodItem v-for="orderItem in row.order_items" :key="orderItem.id" :img="orderItem.good.thumb"
            :sn="orderItem.good.good_no" :name="orderItem.good.title" :price="orderItem.payment" :num="orderItem.num"
            class="good-item" />
        </template>
      </el-table-column>
      <el-table-column prop="payment" label="总价" align="center" v-slot="{ row }">
        ￥{{ row.payment }}
      </el-table-column>
      <el-table-column prop="member" label="客户信息" header-align="center">
        <template v-slot="{ row }">
          <p>
            <i class="el-icon-user"></i>
            <span style="margin-left: 5px;">
              {{ row.member && row.member.nickname ? row.member.nickname : '' }}
            </span>
          </p>
          <p>
            <i class="el-icon-mobile-phone"></i>
            <span style="margin-left: 5px;">
              {{ row.member && row.member.mobile ? row.member.mobile : '' }}
            </span>
          </p>
          <p>
            <i class="el-icon-location-outline"></i>
            <span style="margin-left: 5px;">
              {{ row.member && row.member.address ? row.member.address : '' }}
            </span>
          </p>
        </template>
      </el-table-column>
      <el-table-column prop="order_items" label="订单信息" header-align="center">
        <template v-slot="{ row }">
          <p class="orderinfo">订单号：{{ row.order_no }}</p>
          <p class="orderinfo">下单时间：{{ row.created_at }}</p>
          <p class="orderinfo">付款时间：{{ row.payed_at }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="status_text" label="订单状态" align="center"></el-table-column>
    </el-table>

    <el-pagination background layout="prev,pager,next,total" :current-page.sync="queryForm.page" :total="total"
      :page-size="pageSize" @current-change="getData" class="margin-t-10"></el-pagination>
  </div>
</template>

<script>
  import GoodItem from './components/GoodItem.vue'

  export default {
    components: {
      GoodItem,
    },
    data() {
      return {
        queryForm: {
          page: 1,
          status: '',
          keyword: '',
          slc_type: '',
        },

        loading: false,
        tableData: [],
        total: 0,
        pageSize: 0,
        date: '',
        actTableType: '0',
        counts: {},
      }
    },
    created() {
      this.getData()
    },
    methods: {
      handleSearch() {
        this.queryForm.page = 1
        this.getData()
      },
      handleTabChange(tab) {
        this.queryForm.page = 1

        if (tab.name == 0) {
          this.queryForm.status = ''
        }
        if (tab.name != 0) {
          this.queryForm.status = [tab.name]
        }
        this.getData()
      },

      getData() {
        this.loading = true

        this.$util.get('merchant/orders', this.queryForm)
          .then(res => {
            this.loading = false
            this.tableData = res.data
            this.pageSize = res.per_page
            this.total = res.total
            this.counts = res.counts

            for (let i = 0; i < res.data.length; i++) {
              if (typeof res.data[i].order_items[0].good.tags == "string") {
                if (res.data[i].order_items[0].good.tags && res.data[i].order_items[0].good.tags.length > 0) {
                  this.tableData[i].order_items[0].good.tags = this.tableData[i].order_items[0].good.tags.split(',')
                } else {
                  this.tableData[i].order_items[0].good.tags = []
                }
              }
            }
          })
      },
    },
  }
</script>

<style scoped>
  .good-item:not(:last-child) {
    border-bottom: 1px solid #DCDFE6;
  }
</style>